import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Stack } from '@mui/material';
import ShowerIcon from '@mui/icons-material/Shower';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

export const tips = [
  {
    title: 'Daily Wipe Down',
    description: 'Wipe down sinks and counters daily to prevent soap scum and toothpaste buildup.',
  },
  {
    title: 'Tackle Toilet Stains',
    description: 'Use a toilet brush and a disinfecting cleaner at least twice a week for a sparkling bowl.',
  },
  {
    title: 'Shower Power',
    description: 'Spray your shower walls and doors with a vinegar-water mix after each use to prevent hard water stains.',
  },
  {
    title: 'Pro Tip: Grout Deep Clean',
    description: 'Apply a paste of baking soda and hydrogen peroxide to grout, let sit 10 minutes, then scrub with a brush.',
    pro: true,
  },
  {
    title: 'Mirror Magic',
    description: 'Clean mirrors with a microfiber cloth and glass cleaner for a streak-free shine.',
  },
  {
    title: 'Replace Towels Regularly',
    description: 'Swap out bath and hand towels every 3-4 days to keep things fresh and hygienic.',
  },// Append these objects at the end of the `tips` array:
  {
    title: 'Daily Squeegee Ritual',
    description: 'Keep a small squeegee in the shower. Give walls and doors a quick swipe after each use—this prevents soap scum and water spots before they form.',
  },
  {
    title: 'Showerhead Descaling Hack',
    description: 'Fill a plastic bag with white vinegar, tie it around the showerhead overnight, then run hot water in the morning to dissolve mineral buildup for stronger spray and better hygiene.',
  },
  {
    title: 'Invisible Grout Shield',
    description: 'After your baking-soda + H₂O₂ scrub, wipe grout lines with a colorless grout-seal pen to repel moisture and mildew for months, reducing deep-clean frequency.',
  },
  {
    title: 'Under-Sink Drain Tender',
    description: 'Once a month, pour ½ cup baking soda down the drain, follow with 1 cup white vinegar, cover for 5 minutes, then flush with boiling water to keep pipes clear and odor-free.',
  },
  {
    title: 'Ventilation Velvet',
    description: 'Use a long-nozzle vacuum attachment on exhaust-fan grills and air vents quarterly to remove dust build-up that breeds mold spores and reduces airflow.',
  },
  {
    title: 'Mirror Anti-Fog Trick',
    description: 'Rub a thin layer of car wax or shaving cream on mirrors and glass, then buff off to prevent fog buildup during steamy showers.',
  },
  {
    title: 'Hardware Spotlight',
    description: 'Spray metal fixtures with a 1:1 mix of lemon juice and baking soda, let bubble for 2 minutes, then wipe clean to restore factory shine and kill bacteria.',
  }
];

const BathroomTips = () => (
  <Box sx={{ mb: 6 }}>
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <ShowerIcon color="primary" sx={{ fontSize: 40 }} />
      <Typography variant="h4" fontWeight={700}>
        Bathroom Cleaning Tips
      </Typography>
    </Stack>
    <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
      Keep your bathroom sparkling and sanitary with these expert tips!
    </Typography>
    <Grid container spacing={3}>
      {tips.map((tip, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 1 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
                  {tip.title}
                </Typography>
                {tip.pro && (
                  <Chip icon={<EmojiObjectsIcon />} label="Pro Tip" color="warning" size="small" />
                )}
              </Stack>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                {tip.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Button variant="contained" color="primary" size="large">
        See all bathroom tips
      </Button>
    </Box>
  </Box>
);

export default BathroomTips; 